export class SignConstructionMaterialType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const SignConstructionMaterialTypeChoices = {
  BEAM_60_140: new SignConstructionMaterialType('Balk (60 x 140)', 0),
  PLANKS: new SignConstructionMaterialType('Plank (25 x 100)', 1),
  CROSS_SLATS: new SignConstructionMaterialType('Kruis-lat (25 x 50)', 2),
  BEAM_70_70: new SignConstructionMaterialType('Balk (70 x 70)', 3),
  LEGO_BLOCK: new SignConstructionMaterialType('Legoblok (1t)', 4),
  STONE: new SignConstructionMaterialType('Steen (27kg)', 5),
  CLAMPING_FOOT: new SignConstructionMaterialType('Opspanvoet', 6)
};

export const SignConstructionMaterialTypeChoiceArray = Object.values(
  SignConstructionMaterialTypeChoices
);

export const SupportedLengthsByMaterialTypeOrdinal = new Map<
  number,
  Set<number>
>([
  [
    SignConstructionMaterialTypeChoices.BEAM_60_140.ordinal,
    new Set([600, 450, 390, 300, 225, 180, 150, 120, 60])
  ],
  [
    SignConstructionMaterialTypeChoices.PLANKS.ordinal,
    new Set([570, 450, 390, 300, 180, 140])
  ],
  [
    SignConstructionMaterialTypeChoices.CROSS_SLATS.ordinal,
    new Set([570, 450, 300, 225])
  ],
  [SignConstructionMaterialTypeChoices.BEAM_70_70.ordinal, new Set([330])]
]);
